import Collector from './Collector.vue';
export default Collector;
